export default "__VITE_ASSET__BXlOMl6C__"